export default {
  title: 'Go to {{name}} page',
  language: 'עברית',
  items: {
    main: {
      title: 'Home',
    },
    info: {
      title: 'Personal Info',
    },
    service: {
      title: 'Service',
    },
    team: {
      title: 'Team',
    },
    contact: {
      title: 'Contact',
    },
  },
};
